import { useState } from 'react';

import {
    Button,
    VStack,
    HStack,
    Box,
    Text,
    Avatar,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
} from '@chakra-ui/react';

import { AddIcon } from '@chakra-ui/icons';
import { VscRobot } from 'react-icons/vsc';

import SideBarButton from '../Atoms/SideBarButton';

import Const from '../Constants';
import { getAvatarUrl } from '../Utils';

import { useAgentsStore } from '../Stores/AgentsStore';

const AgentsBar = ({ auth }) => {
    const globalAgents = useAgentsStore((state) => state.globalAgents);
    const localAgents = useAgentsStore((state) => state.localAgents);
    const currentAgent = useAgentsStore((state) => state.currentAgent);
    const addAgent = useAgentsStore((state) => state.addAgent);
    const setCurrentAgent = useAgentsStore((state) => state.setCurrentAgent);

    const [expandedGroups, setExpandedGroups] = useState([0, 1]);

    const handleAccordionButtonClick = (index) => {
        setExpandedGroups((prev) =>
            prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
        );
    };

    const renderAgentRow = (agent) => (
        <SideBarButton
            key={agent.id}
            id={agent.id}
            current={currentAgent?.id === agent.id}
            icon={<Avatar src={getAvatarUrl(agent.avatar)} name={agent.name || 'Agent'} size={Const.XS} borderWidth={1} />}
            title={agent.role ? `${agent.name || 'Unnamed Agent'} (${agent.role})` : (agent.name || 'Unnamed Agent')}
            action={() => setCurrentAgent(agent)}
        />
    );

    return (
        <VStack
            w={'260px'}
            minW={'260px'}
            maxW={'260px'}
            height={'100vh'}
            background={Const.Gray46}
            padding={Const.kPadding}
            spacing={Const.kSpacing}
            overflowY={'auto'}
            alignItems={'stretch'}
        >
            <HStack pb={Const.SpaceXS} pl={Const.SpaceXS}>
                <Box color={Const.Orange400}>
                    <VscRobot size={14} />
                </Box>
                <Text color={Const.Gray165} fontSize={Const.XS} fontWeight={Const.Bold}>
                    Agents
                </Text>
            </HStack>

            <Accordion index={expandedGroups} allowMultiple width={'100%'}>
                <AccordionItem border={Const.sNone}>
                    <h2>
                        <AccordionButton
                            _hover={{ background: Const.Gray69 }}
                            onClick={() => handleAccordionButtonClick(0)}
                        >
                            <Box flex={'1'} textAlign={Const.Left} fontSize={Const.SM} fontWeight={Const.Bold} color={Const.Gray180}>
                                Agents
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                        {globalAgents.map((agent) => renderAgentRow(agent))}
                    </AccordionPanel>
                </AccordionItem>

                <AccordionItem border={Const.sNone}>
                    <h2>
                        <AccordionButton
                            _hover={{ background: Const.Gray69 }}
                            onClick={() => handleAccordionButtonClick(1)}
                        >
                            <Box flex={'1'} textAlign={Const.Left} fontSize={Const.SM} fontWeight={Const.Bold} color={Const.Gray180}>
                                My Agents
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                        {localAgents.map((agent) => renderAgentRow(agent))}
                        <Button
                            leftIcon={<AddIcon boxSize={'10px'} />}
                            size={Const.SM}
                            minH={Const.kButtonHeight}
                            width={'100%'}
                            background={Const.Gray46}
                            color={Const.Green500}
                            justifyContent={'flex-start'}
                            _hover={{ background: Const.Gray69, color: Const.White }}
                            onClick={() => addAgent(auth)}
                            mt={Const.SpaceXS}
                        >
                            Add agent
                        </Button>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </VStack>
    );
};

export default AgentsBar;
